import PropTypes from "prop-types";
import { Segment } from "semantic-ui-react";
import { Horizontal } from "./styles";

export const Aligned = ({ isHorizontalComponent, children }) => {
  const Component = isHorizontalComponent ? Horizontal : Segment;
  return <Component>{children}</Component>;
};

Aligned.propTypes = {
  isHorizontalComponent: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};
